var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import S from 's-js';
import * as Surplus from 'surplus';
import { Page } from './Page';
import { PaginatedArticleFeed, ArticlesToggle } from './ArticlesFeed';
import { FollowButton } from './FollowButton';
export { ProfileRoute };
const ProfileRoute = (app, user, favorites) => __awaiter(this, void 0, void 0, function* () {
    const model = ProfileModel(app, user, favorites);
    S(() => app.location(`#/@${user}${model.tab() === 'favorites' ? '/favorites' : ''}`));
    return () => <ProfilePage {...model}/>;
}), ProfileModel = (app, username, favorites) => {
    const tab = S.value(favorites ? 'favorites' : 'my'), profile = S.data({}), isUser = () => app.user() && app.user().username === username, request = app.client.profiles.get(username), feed = () => {
        const filter = tab() === 'my' ? { author: username } : { favorited: username };
        return (q) => app.client.articles.get(Object.assign({}, q, filter));
    };
    request.then(resp => profile(resp.profile));
    return { app, tab, username, isUser, profile, feed };
}, ProfilePage = (props) => (<Page app={props.app} title={`@${props.username} - Conduit`} section={props.isUser() ? 3 /* Profile */ : 6 /* None */}>
            <Profile {...props}/>
        </Page>), Profile = (props) => (<div class="profile-page">
            <UserInfo {...props}/>
            <div class="container">
                <div class="row">
                    <div class="col-xs-12 col-md-10 offset-md-1">

                        <ArticlesToggle tab={props.tab}>{{
    my: 'My Articles',
    favorites: 'Favorited Articles'
}}</ArticlesToggle>

                        <PaginatedArticleFeed size={10} feed={props.feed()} client={props.app.client}/>
                    </div>
                </div>
            </div>
        </div>), UserInfo = ({ profile, isUser, app: { client, user } }) => (<div class="user-info">
            <div class="container">
                <div class="row">
                    <div class="col-xs-12 col-md-10 offset-md-1">
                        <img class="user-img" src={profile().image || '//:0'}/>
                        <h4>{profile().username}</h4>
                        <p>{profile().bio}</p>
                        {isUser()
    ? <a class="btn btn-sm btn-outline-secondary action-btn" href="#/settings">
                                <i class="ion-gear-a"></i> Edit Profile Settings
                            </a>
    : FollowButton(profile, client)}
                    </div>
                </div>
            </div>
        </div>);
